import { render, staticRenderFns } from "./AddCertification.vue?vue&type=template&id=1bdd4286"
import script from "./AddCertification.vue?vue&type=script&lang=js"
export * from "./AddCertification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports